import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { makeStyles, Typography } from "@material-ui/core";
import * as PropTypes from "prop-types";
import {
  GetSet,
  AutoCompleteFilter,
  ListFilter,
} from "../../../../Constants/Jurisdiction";
import TextField from "@material-ui/core/TextField/TextField";
import Dialog from "@material-ui/core/Dialog/Dialog";
import UseCellFormContainer from "../../../../Container/DataEntry/DataEntryTwo_UseWorkflow/Forms/UseCellFormContainer";

const useStyles = makeStyles({
  worxRadioGroupStyleOverride: {
    marginBottom: "1em",
  },
  worxSpaceAround: {
    margin: "0 1em",
  },
  textfieldWrapper: {
    marginBottom: "1em",
  },
  buttonWrapper: {
    marginTop: "1em",
    textAlign: "right",
  },
});

const topCardUseStyles = makeStyles({
  root: {
    "& .MuiDataGrid-cell": {
      whiteSpace: "normal !important",
    },
    marginBottom: "2em",
  },
});

const UseGridMatrixDisplay = (props) => {
  const {
    grid,
    rows,
    columns,
    closeForm,
    addLink,
    initValues,
    rowTotal,
    filters,
    requery = {},
    jurisdictionID,
  } = props;

  let pageSize = 25;

  const classes = useStyles();
  const topCardClasses = topCardUseStyles();

  return (
    <React.Fragment>
      <Typography variant={"h5"} gutterBottom>
        Use Matrix
      </Typography>

      <Dialog
        id={"addLinkForm"}
        open={addLink}
        onClose={closeForm}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <UseCellFormContainer
          grid={grid}
          initValues={initValues}
          closeForm={closeForm}
          requery={requery}
          filters={filters}
          jurisdictionID={jurisdictionID}
        />
      </Dialog>

      <div className={classes.textfieldWrapper}>
        <TextField
          margin="normal"
          id={"use"}
          label={"Use"}
          onChange={(event) => {
            let nextFilter = {
              ...filters.get,
              use: event.target.value,
              offset: 0,
            };
            grid.filter({ variables: nextFilter });
            filters.set(nextFilter);
          }}
          className={classes.worxSpaceAround}
        />
        <TextField
          margin="normal"
          id={"zone"}
          label={"Zone"}
          onChange={(event) => {
            let nextFilter = {
              ...filters.get,
              zone: event.target.value,
              offset: 0,
            };
            grid.filter({ variables: nextFilter });
            filters.set(nextFilter);
          }}
          className={classes.worxSpaceAround}
        />
      </div>

      <DataGrid
        classes={{ root: topCardClasses.root }}
        pagination
        rowCount={rowTotal}
        autoHeight={true}
        getRowHeight={() => "auto"}
        columns={columns}
        rows={rows}
        pageSize={pageSize}
        paginationMode="server"
        onPageChange={(page) => {
          let nextFilter = { ...filters.get, offset: pageSize * page };
          grid.filter({ variables: nextFilter });
          filters.set(nextFilter);
        }}
        loading={!grid.list}
        className={classes.worxSpaceAround}
      />
    </React.Fragment>
  );
};

UseGridMatrixDisplay.propTypes = {
  grid: ListFilter,
  initValues: GetSet,
  statusOptions: AutoCompleteFilter,
  footnoteOptions: AutoCompleteFilter,
  addLink: PropTypes.bool,
  deleteLink: PropTypes.func,
  showForm: PropTypes.func,
  closeForm: PropTypes.func,
  rowTotal: PropTypes.number.isRequired,
  columns: PropTypes.array,
  rows: PropTypes.array,
  filters: GetSet,
  requery: PropTypes.object,
  jurisdictionID: PropTypes.number,
};

export default UseGridMatrixDisplay;
